import { FC } from "react";
import { Link } from "react-router-dom";

export const Menu: FC<{}> = props => {
  return (<>
    <Link to="lastgame" className="bg-goat px-4 py-2 rounded-lg text-3xl cursor-pointer">Resultado da Última Queda</Link>
    <Link to="lastgamemvp" className="bg-goat px-4 py-2 rounded-lg text-3xl cursor-pointer">MVP da Última Queda</Link>
    <Link to="all" className="bg-goat px-4 py-2 rounded-lg text-3xl cursor-pointer">Resultado Geral</Link>
  </>);
}